import type { TabId } from "../pages/EventOS/types";

/** Flat route paths for the unified app shell (Section 4.3). */
export const appNav = {
  home: () => "/home",
  calendar: () => "/calendar",
  events: () => "/events",
  analytics: () => "/finance/analytics",
  finance: () => "/finance",
  financeAnalytics: () => "/finance/analytics",
  financeEvents: () => "/finance/events",
  financeInvoices: () => "/finance/invoices",
  newEvent: (date?: string) => (date ? `/events/new?date=${encodeURIComponent(date)}` : "/events/new"),
  editEvent: (eventId: string) => `/events/${eventId}/edit`,
  artists: () => "/directory/artists",
  venues: () => "/directory/venues",
  contacts: () => "/directory/contacts",
  profile: () => "/profile",
  eventOverview: (eventId: string) => `/events/${eventId}/overview`,
  eventDeals: (eventId: string) => `/events/${eventId}/deals`,
  eventBudget: (eventId: string) => `/events/${eventId}/budget`,
  eventPnl: (eventId: string) => `/events/${eventId}/pnl`,
  eventRunOfShow: (eventId: string) => `/events/${eventId}/run-of-show`,
  eventTickets: (eventId: string) => `/events/${eventId}/tickets`,
  eventLive: (eventId: string) => `/events/${eventId}/live`,
  eventRsvp: (eventId: string) => `/events/${eventId}/rsvp`,
  eventInvites: (eventId: string) => `/events/${eventId}/invites`,
  eventInvoices: (eventId: string) => `/events/${eventId}/invoices`,
  eventContacts: (eventId: string) => `/events/${eventId}/contacts`,
  eventNotes: (eventId: string) => `/events/${eventId}/notes`,
  eventFiles: (eventId: string) => `/events/${eventId}/files`,
  guests: () => "/directory/guests",
  ticketingLinks: () => "/admin/ticketing-links",
  publicRsvp: (inviteToken: string) => `/rsvp/${inviteToken}`,
  publicGuestList: (inviteToken: string) => `/guest-list/${inviteToken}`,
  publicWalkIn: (inviteToken: string) => `/walk-in/${inviteToken}`,
  publicInvite: (token: string) => `/i/${token}`,
  commandCenter: (eventId: string, tab: TabId = "overview") => `/events/${eventId}/live`,
  dashboard: (eventId: string) => `/events/${eventId}/overview`,
  logistics: (eventId: string) => `/events/${eventId}/budget`,
  invoices: (eventId: string) => `/events/${eventId}/invoices`,
};
